<script lang="ts">
	import type { SbLink } from '../types';
	import { editable } from '../editable';
	import type { ISbStoryData } from '@storyblok/js';
	import { getSbUrl } from '$lib/utils/storyblok/url';

	interface Props {
		content: ISbStoryData<{
			label: string;
			link: SbLink;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<a
	use:editable={content}
	href={getSbUrl(content.link)}
	class="-ml-3 p-3 text-[16px] leading-normal tracking-[-.16px] underline decoration-[8%] underline-offset-[25%]"
>
	{content.label}
</a>
